module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_SE.679c5219.txt";